import React, { createContext, useState } from "react";
import {
  STRIPE_CUSTOMER_ID,
  STRIPE_SUBSCRIPTION_EXPIRY,
  COGNITO_EVENT_SIGNIN,
  COGNITO_EVENT_AUTOSIGNIN
} from "../constants";

// Re-export constants for backward compatibility
export const STRIPE_ID_KEY = STRIPE_CUSTOMER_ID;
export const STRIPE_SUB_EXPIRY_KEY = STRIPE_SUBSCRIPTION_EXPIRY;
export { COGNITO_EVENT_SIGNIN, COGNITO_EVENT_AUTOSIGNIN };

export const CognitoUserContext = createContext();

export const CognitoUserProvider = (props) => {
  const a = new Array([]);

  
  const [cognitoUser, setCognitoUser] = useState(a);

  return (
    <CognitoUserContext.Provider
      value={{
        cognitoUser,
        setCognitoUser,
      }}
    >
      {props.children}
    </CognitoUserContext.Provider>
  );
};
